import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ButtonsComponent } from '../../shared/buttons/buttons.component';
import { createNewPwdForm } from './new-pwd.forms';
import {AuthService} from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-new-pwd',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ButtonsComponent,
  ],
  templateUrl: './new-pwd.component.html',
  styleUrls: ['./new-pwd.component.scss'],
})
export class NewPwdComponent implements OnInit {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);

  hidePassword = true;
  hideConfirm = true;

  loading = false;
  success = false;
  error = '';

  token: string | null = null;
  tokenInvalid = false;

  form: FormGroup<{
    password: FormControl<string | null>;
    confirmPassword: FormControl<string | null>;
  }> = createNewPwdForm(this.fb);

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.tokenInvalid = true;
    }
  }

  submit(): void {
    if (this.form.invalid || this.loading || !this.token) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.error = '';
    this.success = false;

    const { password, confirmPassword } = this.form.getRawValue();

    this.auth.resetPassword({
      token: this.token,
      newPassword: password!,
      confirmPassword: confirmPassword!,
    }).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;

        setTimeout(() => {
          this.router.navigateByUrl('/login');
        }, 2000);
      },

      error: (err) => {
        this.loading = false;

        this.error =
          err?.error?.message ??
          'Impossibile aggiornare la password. Il link potrebbe essere scaduto.';
      },
    });
  }
}
